import type { User } from '../types'
import { APP2 } from './api'

export type PlanId = 'free' | 'pro' | 'unlimited'

/** The server normalises the plan in /api/me; unknown → free (same as backend). */
export function planOf(user: User | null | undefined): PlanId {
  const p = (user?.plan || '').toLowerCase()
  return p === 'pro' || p === 'unlimited' ? p : 'free'
}

export const PLAN_LABEL: Record<PlanId, string> = { free: 'Free', pro: 'Pro', unlimited: 'Ilimitado' }

/** Max export short side for the plan (mirrors server limits; server enforces). */
export function maxShortSide(user: User | null | undefined): number {
  return user?.limits?.maxExportShortSide ?? (planOf(user) === 'free' ? 1080 : 2160)
}

export const plansUrl = (ref: string) => `${APP2}/billing/plans?ref=${encodeURIComponent(ref)}`
export const DASHBOARD_URL = `${APP2}/dashboard`
